import socketIOClient from "socket.io-client";
// import { chatbot_api_root } from "../config";
import { chatbot_api_root } from "../configtest";
import eventBus from "../components/chatbot/EventBus";

export let socket1;

// export const sendPrivateMessage = (message) => {
//   socket1.emit("privateMessage", message);
// };

// export const sendNewPrivateMessage = (message) => {
//   socket1.emit("newPrivateMessage", message);
// };

// export const sendUserStatus = (user_id, status) => {
//   socket1.emit("userstatus", { value: status, user_id: user_id });
// };

export const joinRoom = (group_id) => {
  socket1.emit("joinRoom", { group_id });
};

export const initializeHandlers = (userDetails) => {
  // debugger;
  // console.log("Establishing Handlers");
  //Establishing WebSocket
  const socket = socketIOClient.connect(chatbot_api_root, {
    secure: true,
    path: "/dev_chatbot_websocket",
  });

  socket.on("handshake", (data) => {
    // console.log("handshake event");
    socket.emit("createSelfRoom", {
      userDetails: userDetails,
      conversation_id: sessionStorage.getItem("conversation_id"),
      userType: "client",
    });
  });

  socket.on("selfRoomCreated", (data) => {
    //Join all rooms NOTE: here socket i reffer to actual socket id
    socket.emit("joinRooms", {
      username: userDetails.username,
      socketId: data.socketId,
    });
  });

  socket.on("joinRooms_ok", (data) => {
    // console.warn("USER HAS JOINED ALL ROOMS...!!");
  });

  socket.on("joinRoom_ok", (data) => {
    // console.warn("User has joined a new Room");
  });

  //Message Handler
  socket1 = socket;
  // sendUserStatus(userDetails.username, true);
  // connectToRooms(user_id)
  socket1.on("message", (data) => console.warn(data));

  //Various activity handlers (Added to new Group, Group name changes etc.)
  socket1.on("activity", (data) => console.warn(data));

  socket1.on("connection", () => {
    // socket1.emit("crateSelfRoom", {
    //   socketId: socket1.id,
    //   username: userDetails.username,
    // });
    // console.log("Socket Connection recieved..");
  });
};

/**
 * 1. Intialize Handlers when Login == False
 * 2. Removing Socket Handler Dependency with Login == true
 */

// export const initializeNewHandlers = () => {
//   //Establishing WebSocket
//   debugger;
//   console.log("Establishing New Handlers: Sockets");
//   const socket = socketIOClient.connect(chatbot_api_root, {
//     secure: true,
//     path: "/dev_chatbot_websocket",
//   });

//   //Message Handler
//   socket1 = socket;
//   socket1.on("message", (data) => console.warn(data));

//   socket1.on("connection", () => {
//     console.log("Socket Connection Recieved to New Handlers");
//   });
// };

//userVisit
export const sendUserVisit = (payload) => {
  socket1.emit("user_visit", { payload });
};

//userVisit
export const sendUserActivityStatus = (payload) => {
  socket1.emit("user_activity", { payload });
};

export const sendQuery = ({ to, payload , serviceChanger }) => {
  socket1.emit("query", { to, payload, serviceChanger});
};

// Socket Connection to trigger workflows
export const triggerWorkflow = ({ payload }) => {

  console.log("Socket emit for the trigger workflow in the ui")
  socket1.emit("trigger_workflow", { payload });
};


// Socket Connection to trigger workflows
export const sendWorkflowdata = ({ payload, type, language }) => {
  socket1.emit("workflow_data", { payload, type, language });
};
// eventBus.on("")

export const sendUserChoiceYesorNo = ({ payload }) => {
  socket1.emit("workflow_user_yesno", { payload });
};

// export const fouceDisconnectHandoff = ({ conversation }) => {
//   socket1.emit("issue_closed_by_client", conversation);
// };

// export const askHumanHelp = ({
//   username,
//   transcript,
//   activeSocketId,l
//   previous_conversation,
// }) => {
//   socket1.emit("human_help", {
//     username,
//     transcript,
//     activeSocketId,
//     conversation_id: sessionStorage.getItem("conversation_id"),
//     previous_conversation: previous_conversation,
//   });
// };
